/** @format */
import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { Chain } from '@shared/data-access/interfaces';

@Component({
  selector: 'home-page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PageHeaderComponent implements OnInit {
  private readonly chain = inject(Chain);

  @Input() pageTitle: any;
  public breadcrumbs: any = [];
  public chainAbbr: string;

  constructor() {
    this.chainAbbr = this.chain.chainIdentifierAbbr;
  }

  ngOnInit() {
    this.breadcrumbs = this.pageTitle
      .split(' ')
      .map((char) => {
        return char.substr(0, 1).toUpperCase() + char.substring(1).toLowerCase();
      })
      .join(' ');
  }
}
